module.exports = __webpack_public_path__ + "img/about_002.142baea.webp";